// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.box-select2 .multiselect__input,\n.box-select2 .multiselect__single {\n    width: 98% !important;\n}\n", ""]);
// Exports
module.exports = exports;
